import {getRouteApi} from "@tanstack/react-router";

export const expedientOffersRouteApi = getRouteApi("/_app/sales/expedients/$expedientId/offers/");
